<template >
  <div class="container">
    <div class="row justify-content-center" v-if="lesson!=null && topic!=null && qa!=null">
      <div class="col-sm-12" v-bind:class="[withIFrame?'col-md-12': 'col-md-8']">
        <div class="card o-hidden border-1 my-5">
          <div class="card-body p-0">
            <!-- Nested Row within Card Body -->
            <div class="row">
              <div class="col-lg-12">
                <div class="p-4">
                  <form class="user">
                    <div class="text-center">
                      <h2 class="text-primary">Сайн байна уу? {{userData.name}}</h2>
                      <p>schools/{{schoolId}}/lessons/{{this.lessonId}}/topics/{{this.topicId}}/details/{{this.contentId}}</p>
                      <h3>{{lesson.name}} {{showTime}}{{currentUser.uid}}</h3>
                      <h4>{{topic.name}}</h4>
                    </div>
                    <!-- <h5 class="h4 text-gray-900 mb-4 text-center" v-if="qaEnd==true">Асуулгын хугацаа дууссан байна.</h5> -->
                    <div class="row" v-if="qa!=null&&qa.published==true">
                      <div class="col">
                        <div class="text-center">
                          <br/>
                          <h5 class="h2 text-gray-900 mb-4">{{qa.name}}</h5>
                          <h4 v-if="qa.duration"><span class="font-weight-bold">Хугацаа: </span> <span class="text-danger font-weight-bold">{{qa.duration}} минут</span></h4>
                          <div class="row justify-content-md-center" v-if="qa.images!=null && qa.images.length>0">
                              <div class="col-md-12" v-for="(file, index) in qa.images">
                                  <a href="#" class="mb-4 h-100">
                                  <img class="img-fluid" :src="file.fileUrl" />
                                  </a>
                              </div>
                          </div>
                        </div>
                        <p class="text-center">{{qa.description}}</p>
                        <p v-if="testFinished==false" class="">Та шалгалтаа эхлүүлэхийг хүсвэл эхлэх товч дээр дарна уу. Мөн та шалгалтаа нэг эхэлсэн бол ямар нэгэн байдлаар вэбээс гарсан тохиолдолд шалгалтаа үргэлжлүүлэн өгөх боломжгүй болно. Тиймээс вэбээс гаралгүй шалгалтаа дуусгаарай.</p>
                       
                        <div class="alert-warning py-10 text-center" v-if="testFinished==false">
                          <p class="p-10">Та цагаасаа өмнө дуусгахыг хүсвэл заавал <span class="font-weight-bold">"шалгалт дуусгах"</span> товч дээр дарна уу. 
                          Хариулж дууссан товч даралгүй гарвал дүн бодогдохгүй.</p>
                        </div>
                      </div>
                      <hr/>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="row justify-content-center mb-4" v-if="finished!=true&&showStartButton==true">
              <div class="col-md-12 col-sm-12 col-lg-8">
                <form class="user" v-if="qa && qa.published==true">
                  <div class="row justify-content-center">
                    <div class="col-lg-6 col-md-12 text-center" v-if="performingRequest==false">
                      <button v-if="qa" @click="startExam" class="btn btn-danger" style="width:100%">Эхлэх</button>
                        <!-- <button class="btn btn-danger"
                        @click="_goStat()">Статистик харах</button> -->

                    </div>
                    <div class="col-lg-6 col-md-12 text-center" v-if="performingRequest==true">
                      <div class="spinner-border" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                    </div>
                  </div>
                </form>
                <div v-else-if="qa && qa.exampublished!=true" class="alert alert-danger text-center">
                  Одоогоор энэ шалгалт хаалттай байна. Багштайгаа холбоо барина уу
                </div>
                <div v-else class="alert alert-info  text-center">
                  Мэдээлэл олдсонгүй.Та дахин оролдоно уу.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="finished!=true">
      <!-- Outer Row -->
      <div class="row justify-content-center">

        <div class="col-md-12 col-sm-12" v-if="qaFound==true && qa!=null  && finished!=true" >
          <div >
            <div class=" p-0">
                <div class="">
                    <div class="">
                      <div class="p-0">
                        <!-- <div v-if="qa!=null && qa.accessType=='location'">
                          <p class="text-center mb-0"> <span style="color: #e83e8c;">{{group.data().name}}</span></p>
                          <p class="text-center mb-0"> <span style="color: #e83e8c;">{{company.data().name}}</span></p>
                          <p class="text-center mb-0"> <span style="color: #e83e8c;">{{division.data().name}}</span></p>
                          <p class="text-center mb-0"> <span style="color: #e83e8c;">{{section.data().name}}</span></p>
                          <hr/>
                        </div> -->
                        <!-- <h4 class="text-center my-5 font-weight-bold" style="color:#F52949">{{index+1}}. {{category.name}}</h4> -->
                        <div class="card mb-4" v-if="categories!=null && categories.length>1" >                      
                          <div class="card-body">   
                          <button v-for="(category, index) in categories" class="my-2 btn ml-3 btn-default btn-sm" style="font-size:10pt" 
                          v-bind:class="[category.answeredCount!=0 && category.showquestions.length>0 && 
                          category.answeredCount==category.showquestions.length ? 'btn-success' : 'btn-light']" @click="selectCategory(index)">{{category.name}}</button>
                          </div>
                        <!-- v-bind:class="[selectedIndex!=null && selectedIndex==index ? 'btn-primary' : '']" -->
                        </div>
                        <!-- selected category questions -->
                        <div v-if="categories[selectedIndex]!=null">
                          <div class="row justify-content-between mx-3 my-3" v-if="categories && categories.length>1" >
                            <div class="col-auto" >
                              <span style="cursor:pointer;" v-if="selectedIndex>0" @click="prev">
                                <i class="fas fa-chevron-left my-5 font-weight-bold" style="cursor:pointer;font-size: 1.25rem; color:#E83E8C"></i>
                                {{categories[selectedIndex-1].name}}
                              </span>
                            </div>
                            <div class="col-expand">
                              <h5 v-if="categories[selectedIndex].name!=null && categories[selectedIndex].name!=undefined" 
                              class="text-center mb-3 font-weight-bold" style="color:#E83E8C">
                                {{categories[selectedIndex].name}}
                                (
                                <span v-if="categories[selectedIndex].answeredCount!=null">{{categories[selectedIndex].answeredCount}}</span>
                                <span v-else>0</span>
                                <span v-if="categories[selectedIndex].showquestions!=null">/{{categories[selectedIndex].showquestions.length}}</span>
                                <span v-else>/0</span>
                                )
                              </h5>
                            </div>
                            <div class="col-auto" >
                              <span style="cursor:pointer;" @click="next" v-if="categories!=null && categories.length>0 && (categories.length-1) >selectedIndex">
                                {{categories[selectedIndex+1].name}}
                                <i class="fas fa-chevron-right my-5 font-weight-bold" style="cursor:pointer;font-size: 1.25rem; color:#E83E8C"></i>              
                              </span>
                            </div>
                          </div>
                        
                        <!-- <h3 class="h4 text-center p-4">Та доорх асуултанд хариулна уу</h3>
                        -->
                        <!-- categories -->
                        <div class="row justify-content-center">
                          
                          <div class="col-md-8 col-sm-12" v-if="withIFrame && qaFound==true && finished!=true" >
                            <div>
                              <div id="iframecontainer" v-html="qa.iframeurl">
                              </div>
                            </div>
                          </div>
                          <div v-bind:class="[withIFrame?'col-md-4': 'col-md-8']" class="col-sm-12">
                            <div  v-if="categories!=null && categories.length>0">
                                  <div class="card mb-4" v-for="(question, index) in categories[selectedIndex].showquestions">
                                  <!-- v-if="(question.role==null || question.role==undefined) || (userProps!=null && question.role!=null && question.role!=userProps.role)" -->
                                    <div class="card-header">
                                    
                                      <!-- <div >
                                        <p v-if="question.description!=null && question.description!=''">{{question.description}}</p>
                                        
                                      </div> -->
                                
                                      <div v-for="(subquestion, sindex) in question.subquestions">
                                          <div class="d-flex justify-content-between my-2">
                                           <h3 class="m-0 font-weight-bold text-primary" style="font-size:14pt">                                    
                                            <span v-if="numberingType==0">{{index+1}}</span>
                                            <span v-if="numberingType==1">{{question.numbering}}</span> 
                                            . {{question.title}} </h3>
                                        <div><p class="text-primary text-right">{{subquestion.score}} оноо</p></div>

                                      </div>
                                      <div class="row justify-content-md-center mt-2" v-if="question.images!=null && question.images.length>0">
                                          <div class="col-md-12" v-for="(file, index) in question.images">
                                              <a :href="file.fileUrl" target="blank" class="d-block mb-4 h-100">
                                              <img class="img-fluid img-thumbnail" :src="file.fileUrl" />
                                              </a>
                                          </div>
                                      </div>
                                        
                                        <div>
                                          <p v-if="subquestion.description!=null && subquestion.description!=''">{{subquestion.description}}</p>
                                        </div>
                                        <div v-if="subquestion.multichoice==true" class="mb-2">Сонголт: {{subquestion.mcanswers.length}}</div>
                                        
                                        <div v-if="subquestion.answertype!=true">
                                          <div class="mb-2" v-if="subquestion.answers!=null && subquestion.answers.length>0">
                                            <div v-if="vertical==true">
                                              <ul class="list-group" v-if="subquestion.multichoice==true">
                                                <li
                                                  v-for="(answer,index) in subquestion.answers"
                                                  style="cursor:pointer"
                                                  class="list-group-item"
                                                  @click="answerQuestion(question, answer, categories[selectedIndex], subquestion)"
                                                  v-bind:class="[answer.useranswer!=null && answer.useranswer.answer!=null && answer.useranswer.answer.id==answer.id ? 'answered' : '']"
                                                >
                                                  <div class="row">
                                                    <!-- if it is multichoice, README -->
                                                    <div class="col col-12"><p class="text-dark mb-0">{{answer.name}}</p></div>
                                                    <!-- <div class="col col-2"><span class="badge badge-primary badge-pill">{{answer.votedCount}}</span></div> -->
                                                  </div>
                                                  <img v-if="answer.image!=null" class="img-thumbnail" :src="answer.image.fileUrl" alt="">
                                                </li>
                                              </ul>
                                              <ul class="list-group" v-else>
                                                <li
                                                  v-for="(answer,index) in subquestion.answers"
                                                  style="cursor:pointer"
                                                  class="list-group-item"
                                                  @click="answerQuestion(question, answer, categories[selectedIndex], subquestion)"
                                                  v-bind:class="[subquestion.useranswer!=null && subquestion.useranswer.answer!=null && subquestion.useranswer.answer.id==answer.id ? 'answered' : '']"
                                                >

                                                  <div class="d-flex">
                                                    <div class="col">
                                                      <!-- this is not multichoice answers README -->
                                                      <div class="d-flex">
                                                           <i v-if="answer.correct && showCorrectAnswer && subquestion.useranswer!=null && subquestion.useranswer.answer!=null && subquestion.useranswer.answer.id==answer.id" 
                                                           
                                                           style="color:#82c91e" class="fas fa-check-circle mr-3 text icon-bg"></i>
                                                           <i v-if="answer.correct==false && showCorrectAnswer && subquestion.useranswer!=null && subquestion.useranswer.answer!=null && subquestion.useranswer.answer.id==answer.id" style="color:red" class="fas fa-times-circle mr-3 text icon-bg"></i>
                                                          <p class="text-dark mb-0">{{answer.name}}</p>
                                                      </div>
                                                    </div>
                                                    <div @click.stop="deleteAnswer(question, answer, categories[selectedIndex], subquestion)"  
                                                         title="Сонголт устгах" class="text-lg" 
                                                         v-if="subquestion.useranswer!=null 
                                                         && subquestion.useranswer.answer!=null 
                                                         && subquestion.useranswer.answer.id==answer.id &&!testFinished">
                                                         <i class="fas fa-times ml-2 text-danger" style="cursor:pointer" ></i>
                                                    </div>
                                                    <!-- <div class="col col-12"><span class="font-weight-bold">{{index+1}}. &nbsp;</span> {{answer.name}}</div> -->
                                                    <!-- <div class="col col-2"><span class="badge badge-primary badge-pill">{{answer.votedCount}}</span></div> -->
                                                  </div>
                                                  <img v-if="answer.image!=null" class="img-thumbnail" :src="answer.image.fileUrl" alt="">
                                                </li>
                                              </ul>
                                            </div>
                                            <div v-else>
                                              <div class="row" v-if="subquestion.multichoice==true">
                                                <div class="col-md-4 " v-for="(answer,index) in subquestion.answers">
                                                  <div class="card" 
                                                    style="cursor:pointer"
                                                    @click="answerQuestion(question, answer, categories[selectedIndex], subquestion)"
                                                    v-bind:class="[answer.useranswer!=null && answer.useranswer.answer!=null && answer.useranswer.answer.id==answer.id ? 'answered' : '']">
                                                    <img v-if="answer.image!=null" class="card-img-top" :src="answer.image.fileUrl" alt="">
                                                    
                                                    <div class="card-body">
                                                      <p class="card-text">{{answer.name}}xxx</p>
                                                      
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="row" v-else>
                                                <div class="col-md-4 " v-for="(answer,index) in subquestion.answers">
                                                  <div class="card m-3"  
                                                    style="cursor:pointer"
                                                    @click="answerQuestion(question, answer, categories[selectedIndex], subquestion)"
                                                    v-bind:class="[subquestion.useranswer!=null && subquestion.useranswer.answer!=null && subquestion.useranswer.answer.id==answer.id ? 'answered' : '']">
                                                    <img v-if="answer.image!=null" class="card-img-top" :src="answer.image.fileUrl" alt="">
                                                    <div class="card-body">
                                                      <p class="card-text">{{answer.name}}aaa</p>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                          <div v-else class="alert alert-success">Одоогоор энэ асуултанд хариулт оруулаагүй байна.</div>
                                        </div>
                                        <div v-else>
                                          <div v-if="question.useranswer!=null">
                                            <p>Таны хариулт: {{question.useranswer.answer}}
                                              <!-- <i class="fas fa-edit" @click="console.log(12)"></i> -->
                                            </p>
                                            <textarea v-model.trim="question.useranswer.answer" v-on:keyup="question.currentAnswerActive=true" v-on:keyup.enter = "answerQuestionText(question, question.useranswer.answer, categories[selectedIndex])" type="text" class="form-control" placeholder="Та хариултаа бичнэ үү" rows="3"/>
                                              <br/>
                                              <span v-if="question.currentAnswerActive==true">
                                              <button v-if=" (question.useranswer.answer!=null && question.useranswer.answer!='')" class="btn btn-small btn-danger" @click="answerQuestionText(question, question.useranswer.answer, categories[selectedIndex])">Хадгалах</button>
                                              </span>
                                              <button class="btn btn-small btn-info" @click="answerQuestionText(question, defaultAnswerText, categories[selectedIndex])">Хариулт байхгүй</button>
                                              <!-- || (question.useranswer.answer!=null && question.useranswer.answer!='') -->
                                          </div>
                                          <div v-else class="form-group">
                                            <textarea v-model.trim="question.currentAnswerText" v-on:keyup="question.currentAnswerActive=true" v-on:keyup.enter = "answerQuestionText(question, question.currentAnswerText, categories[selectedIndex])" type="text" class="form-control" placeholder="Та хариултаа бичнэ үү" rows="3"/>
                                            <br/>
                                              <!-- <button v-if="question.currentAnswerActive==true" class="btn btn-small btn-primary" @click="answerQuestionText(question, question.currentAnswerText, categories[selectedIndex])">Хадгалах</button> -->
                                              
                                              <span v-if="question.currentAnswerActive==true">
                                              <button v-if=" (question.currentAnswerText!=null && question.currentAnswerText!='')" class="btn btn-small btn-danger" @click="answerQuestionText(question, question.currentAnswerText, categories[selectedIndex])">Хадгалах</button>
                                              </span>
                                              <button class="btn btn-small btn-info" @click="answerQuestionText(question, defaultAnswerText, categories[selectedIndex])">Хариулт байхгүй</button>
                                          </div>
                                        </div>
                                      </div>

                                    </div>
                                    <div class="card-footer" v-if="testFinished==false">
                                      <div>
                                        <div class="text-right">
                                          <span class="bagde badge-pill badge-success" style="font-size:10pt;" v-if="question.answered">хариулсан</span>
                                          <span class="bagde badge-pill badge-danger" style="font-size:10pt; background-color:#E83E8C" v-else="">хариулаагүй</span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  
                                </div>
                                <hr class="mb-0"/>

                              <!-- end selected category questions -->
                          </div>
                          </div>
                        </div>
                        <!-- end categories -->

                        <div class="row justify-content-between mx-3 my-3" v-if="categories!=null && categories.length>1" >
                          <div class="col-auto" >
                            <span style="cursor:pointer;" v-if="selectedIndex>0" @click="prev">
                              <i class="fas fa-chevron-left my-5 font-weight-bold" style="cursor:pointer;font-size: 1.25rem;color:#E83E8C"></i>
                              {{categories[selectedIndex-1].name}}
                            </span>
                          </div>
                          <div class="col-expand">
                            <h5 v-if="categories[selectedIndex].name!=null && categories[selectedIndex].name!=undefined" 
                            class="text-center mb-2 font-weight-bold" style="color:#E83E8C">
                              {{categories[selectedIndex].name}}
                              (
                              <span v-if="categories[selectedIndex].answeredCount!=null">{{categories[selectedIndex].answeredCount}}</span>
                              <span v-else>0</span>
                              <span v-if="categories[selectedIndex].showquestions!=null">/{{categories[selectedIndex].showquestions.length}}</span>
                              <span v-else>/0</span>
                              )
                            </h5>
                          </div>
                          <div class="col-auto" >
                            <span style="cursor:pointer;" @click="next" v-if="categories!=null && categories.length>0 && (categories.length-1) >selectedIndex">
                              {{categories[selectedIndex+1].name}}
                              <i class="fas fa-chevron-right my-5 font-weight-bold" style="cursor:pointer;font-size:font-size: 1.25rem; color:#E83E8C"></i>              
                            </span>
                          </div>
                        </div>
                        <div class="text-center my-5" >
                            <!-- <button class="btn btn-danger mx-3" @click="resetQA">RESET</button> -->
                            <button v-if="testFinished==false" class="btn btn-danger" style="background-color:#E83E8C" @click="_finished(true)">Шалгалт дуусгах</button>

                        
                        </div>
                        <div class="text-center my-5">
                              <router-link :to="{name: 'ExamReport', params: {categories:categories}}" class="text-white">
                                <button class="btn btn-danger" style="background-color:#E83E8C">Report</button>
                            </router-link>  
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>
        <div style="position:fixed;top:100px;right:0;" v-if="showTime && startTime && endTime && testFinished==false">
          <vue-countdown-timer v-if="qa.duration"
            style="background-color:#ED3D63;color:white;font-weight:bold;padding:20px;"
              @start_callback="startCallBack('event started')"
              @end_callback="endCallBack('event ended')"
              :start-time="startTime"
              :end-time="endTime"
              :interval="1000"
              label-position="begin"
              :end-text="'Хугацаа дууссан'"
              :hour-txt="'цаг '"
              :minutes-txt="'минут'"
              :seconds-txt="'секунд'">
              <template slot="countdown" slot-scope="scope">
                <span v-if="scope.props.hours!=0">
                  <span>{{scope.props.hours}}</span>&nbsp; <i>{{scope.props.hourTxt}}: </i>
                </span>
                <span v-if="scope.props.minutes!=0">
                  <span>{{scope.props.minutes}}</span>&nbsp; <i>{{scope.props.minutesTxt}}: </i>
                </span>
                <span>{{scope.props.seconds}}</span>&nbsp; <i>{{scope.props.secondsTxt}}</i>
              </template>
            </vue-countdown-timer>
            <div class="text-center my-5" v-if="qaFound==true && qa!=null  && finished!=true" >
                <button class="btn btn-danger" style="background-color:#E83E8C" @click="_finished(true)">Шалгалт дуусгах</button>
            </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <div class="col-md-8 col-sm-12" v-if="qa">
        <div class="card o-hidden border-1 my-5">
          <div class="card-body p-0">
            <h1>finsihed</h1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../firebaseConfig.js");
import firebase from 'firebase'
import { mapState } from "vuex";
import myfunction from '../global/myfunction.js';
var colors=['#000000', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#546E7A', '#26a69a', '#D10CE8'];
export default {
  name: "ExamPage",
  computed: {
    ...mapState(["currentUser", "enabled", "userProfile"])
  },
  mixins:[myfunction],
  data() {
    return {
      userData:null,
      testFinished: false,
      showCorrectAnswer: false,
      performingRequest: false,
      qaCode: "",
      userName: "",
      userPhone: "",
      qaFound: false,
      qa: null,
      questions: [],
      categories:[],
      groups:[],
      companies:[],
      sections:[],
      divisions:[],
      group:null,
      company:null,
      section:null,
      division:null,

      id:null,
      role:1,
      firstCategory:null,
      userProps:null,
      selectedIndex:null,
      numberingType:0,
      questionCount:0,
      defaultAnswerText:'Хариулт байхгүй',
      qaEnd:false,
      lesson:null,
      topic:null,
      vertical:true,
      userRound:null,
      finished:false,
      earnedScore:null,
      showTime:false,
      startTime:null,
      endTime:null,
      correctCount:null,
      incorrectCount:null,
      showStartButton:true,
      lessonPath:null,
      withIFrame:false,
      debug:true


    };
  },
  watch: {
    group: function (newGroup, oldGroup) {
      if(newGroup!=null)
        this.getCompanies(newGroup.ref);
    },
    company: function (newGroup, oldGroup) {
      if(newGroup!=null)
        this.getDivisions(newGroup.ref);
    },
    division: function (newGroup, oldGroup) {
      if(newGroup!=null)
        this.getSections(newGroup.ref);
    },
    selectedIndex:function(newIndex, old){

      if(newIndex!=null)
        this.selectCategory(newIndex);
      
    }
  },
  created() {
    if(this.userProfile && this.userProfile.customer){
        this.userProfile.customer.get().then(doc=>{
          let data=doc.data();
          data.id=doc.id;
          data.ref=doc.ref;
          this.userData = data;
        });
    }
    this.performingRequest=true;
    if (this.lessonId != null && this.lessonId != ""
      && this.topicId != null && this.topicId != ""
      && this.contentId != null && this.contentId != ""
    ) {
      this.qaCode=this.contentId;
      this.lessonPath = 'schools/'+this.schoolId+"/lessons";
      this._initData();
    }
  },
  props: {
      schoolId:{
        required: true,
      },
      lessonId: { 
        required: true,
      },
      topicId: { 
        required: true,
      },
      contentId: { 
        required: true,
      }
  },
  methods: {
    _goStat(){
        // if(topic!=null && item!=null && item.type!=null && item.type!=undefined && (item.type=='exam' || item.type=='test')){
        
        // }
        console.log(this.lessonId, this.topicId, this.contentId);
        this.$router.push({ name: 'ExamResult', params: { schoolId: this.schoolId, lessonId: this.lessonId, topicId: this.topicId, contentId: this.contentId} });
    },
    shuffle:function (a) {
        var j, x, i;
        for (i = a.length - 1; i > 0; i--) {
            j = Math.floor(Math.random() * (i + 1));
            x = a[i];
            a[i] = a[j];
            a[j] = x;
        }
        return a;
    },
    startCallBack: function (x) {
      
    },
    endCallBack: function (x) {
      this._finished(false);
    },
    _initData(){

      fb.db.collection(this.lessonPath).doc(this.lessonId).get().then(lessonDoc=>{
        let lessonObject=lessonDoc.data();
        lessonObject.id=lessonDoc.id;
        this.lesson=lessonObject;

        lessonDoc.ref.collection("topics").doc(this.topicId).get().then(topicDoc=>{
          let topicObject=topicDoc.data();
          topicObject.id=topicDoc.id;
          this.topic=topicObject;
          topicDoc.ref.collection("details").doc(this.contentId).get().then(doc=>{
            this.performingRequest=false;

              if(doc.exists){
                this.id=doc.id;
                let qa=doc.data();
                qa.id=doc.id;
                this.qa=qa;
                if(this.qa.iframeurl && this.qa.iframeurl!='' && this.qa!=null ){
                  this.withIFrame = true;
                }  
                
              }
              else{
                alert("Мэдээлэл олдсонгүй.")
              }
          });
        });
      });
    },
    async createNewUser(){

      var qaRef=fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId);
      console.log(qaRef.path);
      if(this.currentUser!=null && this.currentUser!=undefined && this.currentUser.uid!=null && this.currentUser.uid!=undefined){
        var newUserRef= qaRef.collection("users").doc(this.currentUser.uid);      
        var userDoc=await newUserRef.get();
 
        if(userDoc.exists){
          var tmpUser=
          {
            lastAccessDate:new Date()
          };
          await newUserRef.update(tmpUser);
        }
        else{
          var tmpUser=
          {
            lastAccessDate:new Date(),
            createdAt:new Date()
            
          };
          await newUserRef.set(tmpUser);
        }

      }
      else{
        alert("Та энэ үйлдлийг хийх эрхгүй байна.");
      }
    },
    async loadRoundData(qaRef){
      
      // var path = "schools/"+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+this.topicId+'/details/'+this.contentId;
      // var qaRef = fb.db.doc(path);
      var userDoc=await qaRef.collection("users").doc(this.currentUser.uid).get();
      await this.createNewUser();

      var roundCount=await userDoc.ref.collection("rounds").orderBy("createdAt", "desc").get();
      console.log('1...');
      console.log(roundCount.size);
     
      var roundCreate=roundCount.size+1;
      var newRound=userDoc.ref.collection("rounds").doc(roundCreate.toString());
      await newRound.set({
        "createdAt":new Date(),
        "userId": this.currentUser.uid
      });
      this.userRound=await newRound.get();

      userDoc.ref.set({
        "lastAccess": new Date(),
        "lastRound": newRound.id,
        "totalRound": roundCreate
      },{merge:true});
          
      this.finished=false;
      this.showStartButton=false;

      this.userRound.ref.onSnapshot(roundDoc=>{
        if(roundDoc.exists && roundDoc.data().earnedScore!=undefined && roundDoc.data().earnedScore!=null)
          this.earnedScore=roundDoc.data().earnedScore;
          this.correctCount=roundDoc.data().answeredCorrect;
          this.incorrectCount=roundDoc.data().answeredIncorrect;
          
      });
    },
    async startExam() {
      this.performingRequest = true;
      var qaRef = fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId);
      await this.loadRoundData(qaRef);    
      
      if(this.finished==true)
      {
        this.performingRequest=false;
        this._finished(false);
        alert("Та шалгалтаа өгсөн байна.");
        return;
      }
      if(this.qa!=null && this.qa.id!=null){
        this.qaFound=true;
        var qaRef=fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId);

        if(this.currentUser!=null && this.currentUser!=undefined && this.currentUser.uid!=null && this.currentUser.uid!=undefined){
          var newUserRef= qaRef.collection("users").doc(this.currentUser.uid);
          var tmpUser= {lastStartAt: fb.firestore.FieldValue.arrayUnion(new Date()),};
          newUserRef.set(tmpUser,{merge:true});
          this.startTime=new Date().getTime();
          var minute=60;
          if(this.qa!=null && this.qa!=undefined && this.qa.time!=null && this.qa.time!=undefined && this.qa.time>0)
            minute=this.qa.time;
          this.endTime= new Date(this.startTime + (minute*60000)).getTime();
          // this.endTime=(new Date().getMinutes()+60).getTime();
          this.showTime=true;
          //this._getQuestionsFromQA(qaRef);
          this._getXAsuulgaCategories(qaRef)
        }
        else
          alert('Та энэ үйлдлийг хийх эрхгүй байна.');
      }
        else
          alert("Мэдээлэл олдсонгүй.");
        this.performingRequest=false;
    },
    _saveScores(){
      var contentDoc=fb.db.collection("schools/"+this.schoolId+"/lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId).collection("users").doc(this.userData.id);
      contentDoc.set({accessed:new Date()});
      for(var category of this.categories){
        //this.results.push({category:true, name:category.name, count:0});
        for(var question of category.questions){
          //console.log(question);
          for(var subquestion of question.subquestions){
            //console.log(subquestion.title, subquestion.useranswer.correct, subquestion.score);
            var finalScore;
            if(subquestion.useranswer.correct==true)
                finalScore = subquestion.score;
            else
                finalScore = 0;
            this.finalScore = this.finalScore + finalScore;
            this.totalScore = this.totalScore + subquestion.score
            //this.results.push({qid: subquestion.id, category:false, name:subquestion.title, score: subquestion.score, finalscore: finalScore});
            
           
             contentDoc.collection('answers').doc(subquestion.id).set({name:subquestion.title, score: subquestion.score, finalScore: finalScore}) //TODOE
           

            for(var answer of subquestion.answers){
              //console.log(answer);
            }
          }
        }
      }
    },
    _finished(showConfirm){
      if(this.qa!=null){
        if(showConfirm){
          var r = confirm("Та дуусгах уу. Цаг хараахан дуусаагүй байна.");
          if (r == true) {
            
          } 
          else {
            return;         
          }
        }
        this.showCorrectAnswer = true;
        this.testFinished = true;
        var path = "schools/"+this.schoolId+"/lessons/"+this.lessonId+"/topics/"+ this.topicId+"/details/"+this.contentId;
        //+"/sstudents"
        console.log(path);
        console.log(this.currentUser.uid);
        this._saveScores();
        // fb.db.collection(path).doc(student.id).set({
        //   modifiedAt: new Date()
        // }, {merge:true});

        // if(this.currentUser!=null && this.currentUser!=undefined && this.currentUser.uid!=null){
        
        //   var submitAnswerFunction = firebase.functions().httpsCallable('finishRound');
        //   var object={
        //     user:this.currentUser.uid,
        //     testPath:fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).collection('details').doc(this.contentId).path,
        //     round: this.userRound.id,
        //     topicPath:fb.db.collection("lessons").doc(this.lessonId).collection("topics").doc(this.topicId).path,
        //     lessonPath:fb.db.collection("lessons").doc(this.lessonId).path,

        //   };
        //   this.finished=true;
        //   // submitAnswerFunction(
        //   //   object
        //   // ).then((result) => {

        //   // })
        //   // .catch(function (error) {
        //   //   console.log(error)
        //   // })

        // }
        // this.showTime=false;
        // this.qaFound=false;
        // // this.qa=null
        // this.questions=[];
        // // this.resetCategory();
        // this.categories=[]
        // // this.selectedCategory=null;
        // this.selectedIndex=null;
        // this.numberingType=0;
        // this.questionCount=0;
     
        // jQuery(window).scrollTop(0);

        // this.performingRequest=false;
      }
    },
    resetQA(){
      if(this.qa!=null){
        
        this.userProps=null;
        var userId='qa_'+this.qa.id+"_user";
        if($cookies.get(userId)!=null){
          var newUserRef= fb.db.collection("asuulga").doc(this.qa.id).collection("users").doc($cookies.get(userId));
          newUserRef.update({finished: true})
          $cookies.remove(userId);
        }
        
      this.createNewUser();
  
        this.qaFound=false;
        this.questions=[]
        this.resetCategory();
        this.selectedIndex=null;
        this.numberingType=0;
        this.questionCount=0;
        if(this.section!=null){
          this.section.ref.update({
            notFinished: fb.firestore.FieldValue.increment(1)
          })
        }

        jQuery(window).scrollTop(0);
        // alert("Баярлалаа. Та амжилттай санал өгч дууслаа.")
        this.company=null;
        this.group=null;
        this.division=null;
        this.section=null;
        this.performingRequest=false;
      }
    },
    resetCategory(){
      this.categories.forEach((category, index)=>{
        category.answeredCount=0;
        category.showquestions=[];
        category.questions.forEach((question)=>{
          question.answered=false;
          question.answers=[];
          question.answeredCount=null;
          question.useranswer=null;
          question.currentAnswerText=null;
          question.currentAnswerActive=false;

          question.answers.forEach((answer)=>{
            // answer.answered=false;
            answer.useranswer=null;
            
          });

        })
      });
      
      this.performingRequest=false;
    },
    
    _getUserAnswerSq(question, ref, category, topquestion){
        var userId='qa_'+this.qa.id+"_user";
        if(question.useranswer==undefined)
                question.useranswer=null;
        ref.collection("votedusers").doc($cookies.get(userId)).onSnapshot(doc=> {
            
            question.useranswer=null;
            if (doc.exists) {
                question.useranswer=doc.data()
                
                if(question.answered!=true){
                  if(topquestion.answeredCount==null)
                    topquestion.answeredCount=0;
                  topquestion.answeredCount++;
                  if(topquestion.answeredCount==topquestion.subquestions.length){
                    topquestion.answered=true;
                    if(category!=null)
                      category.answeredCount++;
                  }
                }
                question.answered=true;
            }
        });  
      },
    
  getRandomColor() {
      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
  },
  async answerQuestion(question, answer, category, subquestion){
    if(subquestion.multichoice==true){
          var questionRef;
          if(category!=null){
            questionRef=fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/"+question.id+"/subquestions").doc(subquestion.id);
          }
          var answerCategory;
          var answerQuestion;
          var answerRef=questionRef.collection("answers").doc(answer.id);
          answerCategory=await this.userRound.ref.collection("categories").doc(category.id).get();
          if(!answerCategory.exists){
            answerCategory.ref.set({
              "category": fb.db.doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id),
              "createdAt":new Date()
            });
          }

          if(answerCategory!=null && answerCategory!=undefined){
            answerQuestion=await answerCategory.ref.collection("roundCategoryQuestions").doc(subquestion.id).get();
            if(answerQuestion.exists!=true){
              var isCorrect=this.checkMultichoiceAnswer([], subquestion, answer);
              answerQuestion.ref.set({
                "question":fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/").doc(question.id),
                "multichoice": subquestion.multichoice,
                "createdAt":new Date(),
                "userId": this.currentUser.uid,
                "subquestion": questionRef,
                "answers": [
                  {
                    "answer":answerRef,
                    'answerText':answer.name,
                    'correct': answer['correct']==true?true:false,
                  }
                ],
                'correct': isCorrect==true?true:false,
                "score": isCorrect==true && subquestion['score']!=undefined?subquestion['score']:0,

              });
              answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)});
           
            }
            else{
              var found=false;
              var foundIndex=0;
              if(answerQuestion.data().answers!=null && answerQuestion.data().answers!=undefined){
                answerQuestion.data().answers.forEach((uanswer, aindex)=>{
                  if(uanswer.answer!=null && uanswer.answer!=undefined && uanswer.answer.id==answer.id){
                    found=true;
                    foundIndex=aindex;
                  }
                });
              }
              if(found==false){
                var isCorrect=this.checkMultichoiceAnswer(subquestion.mcanswers,subquestion,  answer);
                answerQuestion.ref.update({
                  "question":fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/").doc(question.id),
                  "multichoice": subquestion.multichoice,
                  "createdAt":new Date(),
                  "userId": this.currentUser.uid,
                  "subquestion": questionRef,
                  "answers": fb.firestore.FieldValue.arrayUnion({
                      "answer":answerRef,
                      'answerText':answer.name,
                      'correct': answer['correct']==true?true:false,
                    }),
                  'correct': isCorrect==true?true:false,
                  "score": isCorrect==true && subquestion['score']!=undefined?subquestion['score']:0,

                });
                answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)});
              }
              else{
                var tmp=[];
                tmp=answerQuestion.data().answers;
                tmp.splice(foundIndex, 1);

                var isCorrect=this.checkMultichoiceAnswer(tmp, subquestion, null);


                answerQuestion.ref.update({
                  "question":fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/").doc(question.id),
                  "multichoice": subquestion.multichoice,
                  "createdAt":new Date(),
                  "userId": this.currentUser.uid,
                  "subquestion": questionRef,
                  "answers": tmp,
                  'correct': isCorrect,
                  "score": isCorrect==true && subquestion['score']!=undefined?subquestion['score']:0,

                });


                answerRef.update({votedCount:fb.firestore.FieldValue.increment(-1)})
                if(subquestion.answeredCount!=null)
                  subquestion.answeredCount--;
                if(subquestion.answeredCount==0){
                  subquestion.answered=false;
                  question.answered=false;
                  question.answeredCount--;
                  if(category!=null && category.answeredCount!=null)
                    --category.answeredCount;
                }
              }
            }
          }
          // var ref=questionRef.collection("votedusers").doc($cookies.get(userId)+"_"+answer.id);
          
          // ref.delete();
    }

    else{
       var questionRef;
          if(category!=null){
            questionRef=fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/"+question.id+"/subquestions").doc(subquestion.id);
          }
          var answerCategory;
          var answerQuestion;
          var answerRef=questionRef.collection("answers").doc(answer.id);
          answerCategory=await this.userRound.ref.collection("categories").doc(category.id).get();
          if(!answerCategory.exists){
            answerCategory.ref.set({
              "category": fb.db.doc("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id),
              "createdAt":new Date()
            });
          }

          if(answerCategory!=null && answerCategory!=undefined){
            answerQuestion=await answerCategory.ref.collection("roundCategoryQuestions").doc(subquestion.id).get();
            if(answerQuestion.exists!=true){
              answerQuestion.ref.set({
                "question":fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/").doc(question.id),
                "multichoice": subquestion.multichoice,
                "createdAt":new Date(),
                "userId": this.currentUser.uid,
                "subquestion": questionRef,
                "answer":answerRef,
                'answerText':answer.name,
                'correct': answer['correct']==true?true:false,
                "score": answer['correct']==true && subquestion['score']!=undefined?subquestion['score']:0,

              });
              answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)});
           
            }
            else{
          
                answerQuestion.ref.update({
                  "question":fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/").doc(question.id),
                  "multichoice": subquestion.multichoice,
                  "createdAt":new Date(),
                  "userId": this.currentUser.uid,
                  "subquestion": questionRef,
                  "answer":answerRef,
                  'answerText':answer.name,
                  'correct': answer['correct']==true ?true:false,
                  "score": answer['correct']==true && subquestion['score']!=undefined?subquestion['score']:0,

                });
                answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)});
           
       
          }
          // var ref=questionRef.collection("votedusers").doc($cookies.get(userId)+"_"+answer.id);
          
          // ref.delete();
          answerRef.update({votedCount:fb.firestore.FieldValue.increment(-1)})
          // if(question.answeredCount!=null)
          //   question.answeredCount--;
          // if(question.answeredCount==0){
          //   question.answered=false;
          //   if(category!=null && category.answeredCount!=null)
          //     --category.answeredCount;
          // }
        }
      

    }

  },
  answerQuestionText(question, text, category){
    if(text==null || text=='')
      text=this.defaultAnswerText;
      var questionRef;
      if(category!=null){
        questionRef=fb.db.collection("asuulga/"+this.qa.id+"/tests/"+category.id+"/questions").doc(question.id);
      }
      else
        questionRef=fb.db.collection("asuulga/"+this.qa.id+"/questions").doc(question.id);
          // var questionRef=fb.db.collection("asuulga/"+this.qa.id+"/questions").doc(question.id);
        var userId='qa_'+this.qa.id+"_user";
          var ref=questionRef.collection("votedusers").doc($cookies.get(userId))

          ref.get().then(answerdata=>{
            if(answerdata!=null && answerdata.exists){
              ref.update({
                modifiedAt: new Date(),
                answer: text,
              })
            }
            else{
              ref.set(
                {
                    userId:$cookies.get(userId),
                    user:  fb.db.collection("asuulga/"+this.qa.id+"/users").doc($cookies.get(userId)),
                    // userName:this.userName,
                    guest:true,
                    date:new Date(),
                    answer: text,
                    answertype:true
                }
              );
              var questionCountRef=fb.db.collection("asuulga/"+this.qa.id+"/votedCount").doc(question.id);
              questionCountRef.get().then(data=>{
                if(data.exists){
                  questionCountRef.update({votedCount:fb.firestore.FieldValue.increment(1)})
                }
                else{
                  questionCountRef.set({votedCount:fb.firestore.FieldValue.increment(1), questionId:question.id})
                }
              });
              
            }
          });
          
        question.answerQuestionText=null;

  },

  answerDefaultQuestion(question, answer, category){

    if(question!=null && answer!=null){
      var name=question.propertyName;
      if(this.userProps==null){
        var tmp={};
        tmp['age']=null;
        tmp['workYear']=null;
        tmp['role']=null;
        tmp['gender']=null;
        tmp[name]=answer.name;
        this.userProps=tmp;
      }
      else
        this.userProps[name]=answer.name;
      question.answered=true;
    }

    var userId='qa_'+this.qa.id+"_user";
    if($cookies.get(userId)!=null){
      var newUserRef= fb.db.collection("asuulga").doc(this.qa.id).collection("users").doc($cookies.get(userId));
      newUserRef.update(this.userProps);
    }
    var questionRef;
    if(category!=null){
      questionRef=fb.db.collection("asuulga/"+this.qa.id+"/tests/"+category.id+"/questions").doc(question.id);
    }
    else
      questionRef=fb.db.collection("asuulga/"+this.qa.id+"/questions").doc(question.id);
    var ref=questionRef.collection("votedusers").doc($cookies.get(userId))
    var answerRef=questionRef.collection("answers").doc(answer.id)

      answerRef.update({votedCount:fb.firestore.FieldValue.increment(1)})
      var questionCountRef=fb.db.collection("asuulga/"+this.qa.id+"/votedCount").doc(question.id);
      questionCountRef.get().then(data=>{
        if(data.exists){
          questionCountRef.update({votedCount:fb.firestore.FieldValue.increment(1)})
        }
        else{
          questionCountRef.set({votedCount:fb.firestore.FieldValue.increment(1), questionId:question.id})
        }
      });
    
    if(question.useranswer!=null && question.useranswer.answer!=null){
      question.useranswer.answer.update({votedCount:fb.firestore.FieldValue.increment(-1)});
    }

    ref.set(
        {
            userId:$cookies.get(userId),
            user: fb.db.collection("asuulga/"+this.qa.id+"/users").doc($cookies.get(userId)),
            // userName:this.userName,
            guest:true,
            date:new Date(),
            // isCorrect: answer.correct,
            answer:answerRef, 
            answerId: answer.id,
            answertype:false,
        }
    );


  },
  checkMultichoiceAnswer(myanswers,question, lastAnswer, direct){
    var correct=true;
    var totalCorrectCount=0;
    var userCorrect=0;
    question.answers.forEach((answer)=>{
   
      if(answer.correct==true){
        totalCorrectCount++;
        myanswers.forEach((ua)=>{
          if(this.checkAnswerIn(answer, ua)==true){
            userCorrect++;
          }
          else{
            if(lastAnswer!=null && answer.id!=lastAnswer.id)
              correct=false;
          }
        });
      }
    });
   
    if(lastAnswer!=null &&  lastAnswer.correct==true)
      userCorrect++;

    if(totalCorrectCount==userCorrect && correct==true)
      return true;
    return false;
  },
  checkAnswerIn(answerDoc, answer){

    if(answerDoc.id==answer.answer.id ){
      return true;
    }
    
    return false;
  },

    remove(index, array) {
      if (array != null && array.length > 0) array.splice(index, 1);
    },


    selectCategory(index){
      if(this.categories!=null && this.categories.length>0 && this.categories.length>index && this.selectedIndex!=index){
        // if(this.categories[this.selectedIndex]!=null && this.categories[this.selectedIndex].answeredCount!=null && this.categories[this.selectedIndex].answeredCount<this.categories[this.selectedIndex].showquestions.length){
        //   alert("Та эхлээд "+this.categories[this.selectedIndex].name+" бүлгийн асуултуудад хариулж дуусгана уу.");
        // }
        // else{
          this.selectedIndex=index;
          jQuery(window).scrollTop(0);
        // }
      }
    },
    next(){
      if(this.categories!=null && this.categories.length>0 && this.categories.length>(this.selectedIndex+1)){
        // if(this.categories[this.selectedIndex]!=null && this.categories[this.selectedIndex].answeredCount!=null && this.categories[this.selectedIndex].answeredCount<this.categories[this.selectedIndex].showquestions.length){
        //   alert("Та эхлээд "+this.categories[this.selectedIndex].name+" бүлгийн асуултуудад хариулж дуусгана уу.");
        // }
        // else{
          ++this.selectedIndex;
          jQuery(window).scrollTop(0);
        // }
        // this.selectedCategory=this.categories[++this.selectedIndex];
      }
    },
    prev(){
      if(this.categories!=null && this.categories.length>0 && (this.selectedIndex-1)>=0){
        // if(this.categories[this.selectedIndex]!=null && this.categories[this.selectedIndex].answeredCount!=null && this.categories[this.selectedIndex].answeredCount<this.categories[this.selectedIndex].showquestions.length){
        //   alert("Та эхлээд "+this.categories[this.selectedIndex].name+" бүлгийн асуултуудад хариулж дуусгана уу.");
        // }
        // else{
          --this.selectedIndex;
          jQuery(window).scrollTop(0);
        // }
        // this.selectedCategory=this.categories[--this.selectedIndex];
      }
    },
    // setCategoryIndex(index){
    //   if(this.categories[this.selectedIndex]!=null && this.categories[this.selectedIndex].answeredCount!=null && this.categories[old].answeredCount<this.categories[this.selectedIndex].showquestions.length){
    //     alert("Та эхлээд "+this.categories[this.selectedIndex].name+" бүлгийн асуултуудад хариулж дуусгана уу.");
    //   }
    //   else
    //     this.selectedIndex=index;
        
    // }

    async deleteAnswer(question, answer, category, subquestion){
      if(subquestion.multichoice==true){
            var questionRef;
            if(category!=null){
              questionRef=fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/"+question.id+"/subquestions").doc(subquestion.id);
            }
            var answerCategory;
            var answerQuestion;
            var answerRef=questionRef.collection("answers").doc(answer.id);
            answerCategory=await this.userRound.ref.collection("categories").doc(category.id).get();

            if(answerCategory!=null && answerCategory!=undefined){
              answerQuestion=await answerCategory.ref.collection("roundCategoryQuestions").doc(subquestion.id).get();
              if(answerQuestion.exists!=true){
            
              }
              else{
                var found=false;
                var foundIndex=0;
                if(answerQuestion.data().answers!=null && answerQuestion.data().answers!=undefined){
                  answerQuestion.data().answers.forEach((uanswer, aindex)=>{
                    if(uanswer.answer!=null && uanswer.answer!=undefined && uanswer.answer.id==answer.id){
                      found=true;
                      foundIndex=aindex;
                    }
                  });
                }
                if(found==false){

                }
                else{
                  var tmp=[];
                  tmp=answerQuestion.data().answers;
                  tmp.splice(foundIndex, 1);

                  var isCorrect=this.checkMultichoiceAnswer(tmp, subquestion, null);


                  answerQuestion.ref.update({
                    "question":fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/").doc(question.id),
                    "multichoice": subquestion.multichoice,
                    "createdAt":new Date(),
                    "userId": this.currentUser.uid,
                    "subquestion": questionRef,
                    "answers": tmp,
                    'correct': isCorrect,
                    "score": isCorrect==true && subquestion['score']!=undefined?subquestion['score']:0,

                  });


                  answerRef.update({votedCount:fb.firestore.FieldValue.increment(-1)})
                  if(subquestion.answeredCount!=null)
                    subquestion.answeredCount--;
                  if(subquestion.answeredCount==0){
                    subquestion.answered=false;
                    question.answered=false;
                    question.answeredCount--;
                    if(category!=null && category.answeredCount!=null)
                      --category.answeredCount;
                  }
                }
              }
            }
            // var ref=questionRef.collection("votedusers").doc($cookies.get(userId)+"_"+answer.id);
            
            // ref.delete();
      }

      else{
        var questionRef;
        if(category!=null){
          questionRef=fb.db.collection("lessons/"+this.lessonId+"/topics/"+this.topicId+"/details/"+this.contentId+"/tests/"+category.id+"/questions/"+question.id+"/subquestions").doc(subquestion.id);
        }
        var answerCategory;
        var answerQuestion;
        var answerRef=questionRef.collection("answers").doc(answer.id);
        answerCategory=await this.userRound.ref.collection("categories").doc(category.id).get();
      
        if(answerCategory!=null && answerCategory!=undefined){
          answerQuestion=await answerCategory.ref.collection("roundCategoryQuestions").doc(subquestion.id).get();
          if(answerQuestion.exists!=true){
        
          }
          else{
        
            answerQuestion.ref.delete();
            answerRef.update({votedCount:fb.firestore.FieldValue.increment(-1)});
            if(question.answeredCount!=null)
              question.answeredCount--;
            if(question.answeredCount==0){
              question.answered=false;
              if(category!=null && category.answeredCount!=null)
                --category.answeredCount;
            }
          }
        }
      }
    },
  }
};
</script>
<style>
  #iframecontainer iframe{
    width:100%!important;
  }
  .answered{
    background:rgb(207, 207, 207);
    color:black 
  }
</style>
